import Vue from "vue";
import 'element-ui/lib/theme-chalk/index.css'; // 2.2引入样式
import { Menu, MenuItem, Icon, Backtop } from "element-ui";

Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Icon);
Vue.use(Backtop);

